/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_OciInputs */

const en_cargos_oci = /** @type {(inputs: Cargos_OciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCI`)
};

const es_cargos_oci = /** @type {(inputs: Cargos_OciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCI`)
};

/**
* | output |
* | --- |
* | "OCI" |
*
* @param {Cargos_OciInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_oci = /** @type {((inputs?: Cargos_OciInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_OciInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_oci(inputs)
	return es_cargos_oci(inputs)
});